var map = {
	"./demos/basic/index.ts": 93205,
	"./demos/custom/index.ts": 33491,
	"./demos/label/index.ts": 78458,
	"./demos/layout/index.ts": 71226,
	"./demos/remote/index.ts": 46972,
	"./demos/variable/index.ts": 49191
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89942;